var React = require('react');

function LargeCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2916BA","d":"m7.627 17.201-5.69-5.597L0 13.497 7.627 21 24 4.893 22.076 3 7.627 17.201Z"}));
}

LargeCheck.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = LargeCheck;

LargeCheck.default = LargeCheck;
